module.exports = __webpack_public_path__ + "img/pantalla2-6.2699d30b.png";